import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Observable, tap } from 'rxjs';
import { diffObj, equals } from '@hglobal/common';
import { FormType } from '@pt/models';

export function initFormGroup<T extends object>(
  value$: Observable<T>,
  group: FormType<T>,
  ctrl: any,
): FormType<T> {
  value$.pipe(
    tap(value => {
      if (!equals(value, group.value)) {
        group.patchValue(diffObj(value, group.value) as object, { emitEvent: false });
      }
    }),
    takeUntilDestroyed(ctrl.destroyRef),
  ).subscribe();
  return group;
}
